module.exports = __webpack_public_path__ + "static/media/iconParagraph.75cd6120.svg";